export * from './delete-template-request.interface';
export * from './delete-template-response.interface';
export * from './delete-template.shapes';
